import React, { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TagInput from '@wix/da-shared-react/pkg/TagInput';
import { getTierTags } from '../../redux/selectors';
import { useSubmitField } from '../../hooks/useSubmitField';
import { SubmitFormContext } from '../../context';
import { initAdapter, submitAdapter } from './adapters';
import { validator } from './validation';

const TagsField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const { params, pubsub, isEdit } = useContext(SubmitFormContext);

  // Use parent Tier's tags by default if any
  const parentTierTags = useSelector(state =>
    !isEdit && params.tierId ? getTierTags(state, params.tierId) : undefined
  );

  const {
    id,
    field: { ref, value = [], onChange },
    error,
  } = useSubmitField('tags', {
    initAdapter: initAdapter(parentTierTags),
    submitAdapter,
    validator,
  });

  const onTagChange = useCallback(
    newValue => {
      onChange(newValue);
      pubsub.publish('tags', newValue);
    },
    [onChange, pubsub]
  );

  return (
    <TagInput
      withCopy
      id={id}
      label={t('deviationSubmit.form.tags.label')}
      placeholder={t('deviationSubmit.form.tags.placeholder')}
      value={value}
      onChange={onTagChange}
      noBottomSpacing={!params.isPresetsForm}
      validationResult={error && ('error' as any)}
      details={error?.message}
      ref={ref}
    />
  );
};

export default TagsField;
